import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import SearchOffRoundedIcon from '@mui/icons-material/SearchOffRounded'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from '../ui'

export default function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <PageRoot>
      <Panel aria-labelledby="not-found-title">
        <StatusIcon aria-hidden="true"><SearchOffRoundedIcon /></StatusIcon>
        <ErrorCode>404</ErrorCode>
        <h1 id="not-found-title">찾고 있는 페이지가 없어요</h1>
        <Description>
          주소가 바뀌었거나 페이지가 이동되었을 수 있어요.<br />
          홈으로 돌아가 학습을 계속 이어가 주세요.
        </Description>
        <Button onClick={() => navigate('/', { replace: true })}>
          <HomeRoundedIcon aria-hidden="true" fontSize="small" />
          홈으로 돌아가기
        </Button>
      </Panel>
    </PageRoot>
  )
}

const PageRoot = styled.div`
  display: grid;
  min-height: 100vh;
  place-items: center;
  padding: 24px;
  background: ${({ theme }) => theme.colors.background};
`

const Panel = styled.main`
  width: min(100%, 680px);
  padding: clamp(36px, 7vw, 64px);
  text-align: center;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.large};
  background: ${({ theme }) => theme.colors.surface};
  box-shadow: ${({ theme }) => theme.shadow.medium};

  h1 {
    margin: 14px 0 18px;
    color: ${({ theme }) => theme.colors.text};
    font-size: clamp(1.45rem, 3.4vw, 1.8rem);
    line-height: 1.35;
    white-space: nowrap;
    word-break: keep-all;
  }

  button {
    display: inline-flex;
    margin-top: 32px;
    gap: 7px;
  }

  @media (max-width: 620px) {
    h1 { white-space: normal; }
  }
`

const StatusIcon = styled.div`
  display: grid;
  width: 54px;
  height: 54px;
  margin: 0 auto 18px;
  place-items: center;
  color: ${({ theme }) => theme.colors.primary};
  border-radius: 18px;
  background: ${({ theme }) => theme.colors.primarySoft};

  svg { font-size: 28px; }
`

const ErrorCode = styled.span`
  color: ${({ theme }) => theme.colors.progressAccent};
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.18em;
`

const Description = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.7;
`
